import React from "react";
import ClassicoJacke from "../Garments/ClassicoJacke";

export default function ClassicoJackePage() {
  return <ClassicoJacke />;
}
